import {Component, getComponent} from "@symfony/ux-live-component";

/**
 * The root element of the live component the element is in, or null outside a live component.
 */
export const findLiveComponentRoot = (element: HTMLElement): HTMLElement | null => {
    return element.closest<HTMLElement>('[data-controller~="live"]');
};

/**
 * Calls the callback after every render of the live component the element is in and returns a function
 * removing the listener; outside a live component it does nothing. A controller nested in a live
 * component uses it to put its DOM changes in line with the rendered state, because Live re-applies
 * the class and attribute changes made by other scripts on top of every render.
 */
export const onLiveComponentRender = (element: HTMLElement, callback: (component: Component) => void): (() => void) => {
    const root = findLiveComponentRoot(element);
    if (root === null) {
        return () => {};
    }
    let component: Component | null = null;
    let removed = false;
    const hook = (rendered: Component): void => {
        callback(rendered);
    };
    getComponent(root).then((found) => {
        if (!removed) {
            component = found;
            component.on('render:finished', hook);
        }
    }).catch((error) => {
        console.error(error);
    });
    return () => {
        removed = true;
        component?.off('render:finished', hook);
    };
};
